import React, { useContext } from 'react';
import { context } from './context';
import { mapContext } from '../../mapContext';
import { ModalInput } from './ModalInput';
import { Formik } from 'formik';
import { SubmitOnEveryChange } from '../../../components/SubmitOnEveryChange';

export const Agency: React.FC = () => {
  const { agenciesFilters, setSelectedAgencies } = useContext(mapContext);

  return (
    <context.Provider
      value={{
        list: agenciesFilters.agencies.filter(
          ({ ag_lat, ag_lon }) => ag_lat && ag_lon
        ),
      }}
    >
      <Formik<{ title: number[] }>
        initialValues={{ title: [] }}
        onSubmit={(values) => setSelectedAgencies(values.title)}
      >
        {() => (
          <>
            <SubmitOnEveryChange />
            <ModalInput name="title" label="Наименование" />
          </>
        )}
      </Formik>
    </context.Provider>
  );
};
